var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"observer",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
var invalid = ref.invalid;
var reset = ref.reset;
return [_c('artisio-modal',{attrs:{"visible":_vm.modal.show,"title":_vm.$t('Increments'),"ok-title":_vm.$t('Submit'),"is-loading":_vm.loading,"scrollable":""},on:{"show":_vm.onShow,"hidden":_vm.onHidden,"ok":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_c('increment-tiers',{attrs:{"model":_vm.model,"attribute":"increments"}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }